import DarkBgCardsFrame from "@/components/darkBgCards";
import { FEATURES_CONSTANTS } from "./constants";

const FeaturesComp = () => {
  return <DarkBgCardsFrame {...FEATURES_CONSTANTS} />;
};

export default FeaturesComp;
